import { createStore } from 'vuex'
import { cache } from "@/config"
import { getUnreadMessageNums } from '@/api/user/Notice'
import { queryOrders } from "@/api/pay"
import { INTERVAL_TIME_FOR_QUERY } from "@/../public/config"

export default createStore({
  state: {
    //当前用户信息
    userInfo: {},
    //统计未读信息数
    unreadMessageNums: 0,
    //统计未读公告数
    unreadNoticeNums: 0,
    //统计未读站内数
    unreadInStationNums: 0,
    language: cache("language"),
    paymentTimers: new Map(), // 存储多个支付定时器，key: 组件标识, value: timer
    cozeSessionId: '' //扣子对话上文信息
  },
  getters: { //外部访问store.getters.getUnreadMessageNums
    getUnreadMessageNums(state){
      return state.unreadMessageNums;
    },
    getUnreadNoticeNums(state){
      return state.unreadNoticeNums;
    },
    getUnreadInStationNums(state){
      return state.unreadInStationNums;
    }
  },
  mutations: { //同步
    /**
     * 更新登录信息
     * @param {*} state 
     * @param {*} userInfo 
     */
    saveUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      let cacheData = {
        'Authorization-Token': userInfo['Authorization-Token'],
        'Avatar': userInfo['Avatar'],
        'UserName': userInfo['UserName']
      };
      cache("userInfo", cacheData);
      // cache("userInfo", userInfo)
    },
    countUnreadMessageNums(state){ //统计未读信息条数
      getUnreadMessageNums().then((result) => {
        if (result.status == 200) {
          state.unreadNoticeNums = result.data.unreadNoticeNums;
          state.unreadInStationNums = result.data.unreadInStationNums;
          state.unreadMessageNums = state.unreadNoticeNums + state.unreadInStationNums;
        }
      }).catch(() => {
        state.unreadNoticeNums = 0;
        state.unreadInStationNums = 0;
        state.unreadMessageNums = state.unreadNoticeNums + state.unreadInStationNums;
      });
    },
    setLang(state, lang='cn'){ //设置网站语言
      cache("language", lang);
      state.language = lang;
    },
    setPreviousPagePath(state, options){
      cache('previousPagePath', options);
    },
    // 添加定时器
    ADD_PAYMENT_TIMER(state, { key, timer }) {
      // 先清除同名的旧定时器
      if (state.paymentTimers.has(key)) {
        clearInterval(state.paymentTimers.get(key))
      }
      state.paymentTimers.set(key, timer)
    },    
    // 清除指定定时器
    CLEAR_PAYMENT_TIMER(state, key) {
      if (state.paymentTimers.has(key)) {
        clearInterval(state.paymentTimers.get(key))
        state.paymentTimers.delete(key)
      }
    },    
    // 清除所有定时器（登录过期时调用）
    CLEAR_ALL_PAYMENT_TIMERS(state) {
      state.paymentTimers.forEach((timer/*, key*/) => {
        clearInterval(timer)
        // console.log(`[Store] 清除支付定时器: ${key}`)
      })
      state.paymentTimers.clear()
    },
    // 设置coze会话id
    setCozeSessionId(state, id){
      state.cozeSessionId = id
    },
    // 清除coze会话id
    clearCozeSessionId(state){
      state.cozeSessionId = ''
    }
  },
  actions: { //异步
    // countUnreadNoticeNumsAsyn({ commit }) {
    //   setTimeout(() => {
    //     commit('countUnreadNoticeNums');
    //   }, 1000);
    // }
    // 启动支付轮询
    startPaymentPolling({ commit }, { key, orderNo, paytype, lang, callback }) {
      const timer = setInterval(async () => {
        try {
          const res = await queryOrders({ orderNo, paytype, lang })
          if (res.status === 200) {
            callback && callback('success', res)
            commit('CLEAR_PAYMENT_TIMER', key)
          }
        } catch (error) {
          // 继续轮询，或根据错误类型处理
          // console.error(error)
          if(error.status === 500){
            const msg = error?.message ?? ''
            callback && callback('error', msg)
          }
        }
      }, INTERVAL_TIME_FOR_QUERY)
      
      commit('ADD_PAYMENT_TIMER', { key, timer })
      return timer
    },    
    // 停止指定轮询
    stopPaymentPolling({ commit }, key) {
      commit('CLEAR_PAYMENT_TIMER', key)
    },    
    // 停止所有轮询（登录过期时调用）
    stopAllPaymentPolling({ commit }) {
      commit('CLEAR_ALL_PAYMENT_TIMERS')
    }
  },
  modules: {
  }
})
